import cn from 'classnames'
import React from 'react'

import { SiteDataContext } from '../../components'
import RichText from '../../components/rich-text'
import { withAnchor } from '../hooks'
import { THEME } from '@/src/utils/common'

const Cta = ({ title = '', text = null, textTokens = {}, classes = '', children, theme }) => {
  const { isTextRtl } = React.useContext(SiteDataContext)

  return (
    <section
      className={cn('l-section l-section--force-padding c-cta', classes, {
        'c-cta--rtl': isTextRtl,
        'c-cta--dark': theme === THEME.dark
      })}
    >
      <div className="c-cta__content l-container:10/12 l-container--default-spacing">
        <h2 className="c-cta__title">{title}</h2>

        {text && (
          <div className="c-cta__text">
            <RichText data={text} tokens={textTokens} />
          </div>
        )}

        {children && <div className="c-cta__actions">{children}</div>}
      </div>
    </section>
  )
}

export default withAnchor(Cta)
